module.exports = "/assets/a6d709758b5aa098200a6dcf83dbe038.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/VB.png
// module id = 1920
// module chunks = 0